import ServiceItem from "components/molecules/service-item";
import { ServiceItemType } from "components/molecules/service-item/ServiceItem";
import React from "react";
import "./services.scss";

export const Services = () => {
  return (
    <section id="services" className="services">
      <div className="row row-center">
        <div className="col-md-6">
          <div className="services__title">
            <h1 className="services__title__bold">Services</h1>
            <h1 className="services__title__normal">I Offer</h1>
          </div>
          <div className="services__msg">
            <hr />
            <p>
              Better perfomance, faster technologies and responsive design
              applied in every solution.
            </p>
          </div>
        </div>
        <div className="col-md-6">
            <div className="row justify-content-center">
            {
                serviceItems.map((item) => (<ServiceItem key={item.id} {...item} />))
            }
            </div>
        </div>
      </div>
    </section>
  );
};


const serviceItems:ServiceItemType[] = [
    {
        id: 1,
        text: "Mobile & Web Development",
        onNavClick: () => window.open(`${window.location}portfolio#development`)
    },
    {
        id: 2,
        text: "Consulting & Project Management",
        onNavClick: () => window.open(`${window.location}portfolio#development`)
    },
    {
        id: 3,
        text: "Mobile App and Web UI/UX Design",
        onNavClick: () => window.open(`${window.location}portfolio#development`)
    },
];